const formataDataVemString = (dataString) => {
    return dataString.slice(' ', 10);
}

const formataDatas = (dataString) => {
    let dia, mes, ano;
    let data = new Date(dataString);

    dia = data.getDate();
    mes = data.getMonth();
    ano = data.getFullYear();

    dia = data
            .toString()
            .padStart(2, '0');

    mes = mes
            .toString()
            .padStart(2, '0');

    return `${dia}/${mes}/${ano}`;
}

export { formataDataVemString, formataDatas };